import React from 'react';
import { withLocalize} from 'react-localize-redux';
import BbInput from "../../styling/bbInput";
import { connect as connectFormik } from 'formik';
import PropertySkSelectCadastreUnitForm from '../../search/propertySk/searchForms/propertySkSelectCadastreUnitForm';

class CadastreSection extends React.Component {

    render() {
        return (
            <>
                {this.renderCadastre()}
                {this.renderInputText("docNo", "PropertySk.CadastreUnit.OwnershipDeedNo")}
            </>
        );
    }

    renderCadastre() {
        return (
            <PropertySkSelectCadastreUnitForm
                regionId={this.props.formik.values.regionId}
                districtId={this.props.formik.values.districtId}
                municipalityId={this.props.formik.values.municipalityId}
                cadastreUnitId={this.props.formik.values.cadastreUnitId}
                setFieldValue={this.props.formik.setFieldValue}
            />
        );
    }
    renderInputText(key, label) {
        if(this.props.formik.values.cadastreUnitId === "" && this.props.formik.values.docNo !== "")
            this.props.formik.setFieldValue("docNo", "");
        return (
            <div style={{ flexDirection: "row" }} className="col px-1 date-picker-overlay-reversed-direction">
                <BbInput disabled={this.props.formik.values.cadastreUnitId === ""} label={this.props.translate(label)} name={key} type="number" placeholder={{ type: 'column' }} />
            </div>
        );
    }
}

export default withLocalize(connectFormik(CadastreSection))